import React, {
  CSSProperties,
  PropsWithChildren,
  useEffect,
  useRef
} from 'react';
import { createPortal } from 'react-dom';

interface CenteredModalProps extends PropsWithChildren {
  handleClose?: () => void;
  open: boolean;
}

const Backdrop: React.FC<
  PropsWithChildren & {
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  }
> = ({ children, onClick }) => {
  return (
    <div onClick={onClick} style={backdropStyles}>
      {children}
    </div>
  );
};

const CenteredModal: React.FC<CenteredModalProps> = ({
  children,
  open,
  handleClose
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open && modalRef.current) {
      modalRef.current.style.transition = 'none';
      modalRef.current.style.opacity = '0';
      modalRef.current.style.transform = 'scale(0.8)';

      modalRef.current.offsetHeight;

      modalRef.current.style.transition =
        'transform 0.15s ease, opacity 0.2s ease';
      modalRef.current.style.opacity = '1';
      modalRef.current.style.transform = 'scale(1)';
    }
  }, [open]);

  if (!open) return null;

  return createPortal(
    <Backdrop onClick={handleClose}>
      <div
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
        className="modal orange-gradient"
        style={modalStyle}
      >
        {children}
      </div>
    </Backdrop>,
    document.body
  );
};

const backdropStyles: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.6)', // Semi-transparent backdrop
  zIndex: 999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center' // Center the modal vertically and horizontally
};

const modalStyle: CSSProperties = {
  position: 'relative',
  width: '300px',
  height: '440px',
  marginBottom: 60,
  zIndex: 1000,
  padding: '20px',
  borderRadius: '30px', // Rounded corners for a modern look
  backgroundColor: '#fff', // Default white background (adjust as needed)
  opacity: 0, // Initial state for animation
  transform: 'scale(0.8)', // Start slightly scaled down
  overflow: 'hidden' // Prevent content overflow
};

export default CenteredModal;
